import React from 'react';
import type { EditorIconProps } from './EditorIconProps';

export const LlamaClose = ({
  color = 'currentColor',
  size = 40,
  ...props
}: EditorIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      {...props}
    >
      <g transform="translate(8, 7.5)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.502099 2.92645C-0.167366 2.25698 -0.167366 1.17157 0.502099 0.502099C1.17157 -0.167366 2.25698 -0.167366 2.92645 0.502099L23.4977 21.0734C24.1672 21.7429 24.1672 22.8283 23.4977 23.4977C22.8283 24.1672 21.7429 24.1672 21.0734 23.4977L0.502099 2.92645Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M23.4979 3.0205C24.1674 2.35104 24.1674 1.26562 23.4979 0.596155C22.8284 -0.0733113 21.743 -0.0733113 21.0736 0.596155L0.50226 21.1674C-0.167206 21.8369 -0.167206 22.9223 0.50226 23.5918C1.17173 24.2613 2.25715 24.2613 2.92661 23.5918L23.4979 3.0205Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

LlamaClose.displayName = 'LlamaClose';
